import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { FaPlus, FaRegCalendar, FaRegCalendarCheck } from 'react-icons/fa';
import PageContainer from '../../../components/PageContainer';
import ListLayout from '../../../components/ListLayout';
import Loading from '../../../components/Loading';
import useAlertNotification from '../../../context/AlertNotificationContext';
import ErrorRequestService from '../../../services/errorRequest';
import FechamentoApiService from '../../../services/api/FechamentoApiService';
import { columns } from './FechamentoListInfo';
import UtilService from '../../../services/util';
import { FechamentolListHelpModal } from './FechamentolListHelpModal';

const INITIAL_PAGEPARAMS = {
    orderBy: 'cod',
    orderDir: 'asc'
};
const ORDER_DIR_NUM = { asc: 1, desc: -1 };

function FechamentolList(props) {
    // CONTEXT
    const match = useRouteMatch();
    const history = useHistory();
    const alert = useAlertNotification();

    // STATE
    const [rowsData, setRowsData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [orderBy, setOrderBy] = useState(INITIAL_PAGEPARAMS.orderBy);
    const [orderDir, setOrderDir] = useState(INITIAL_PAGEPARAMS.orderDir);
    const [isLoading, setIsLoading] = useState(true);

    // FUNCTIONS
    /** Define o clique sobre um registro da lista */
    const rowClick = (item) => {
        history.push(`${match.path}/${item.id}`, item);
    }

    /** Adiciona click e atributos ao header */
    const getListHeader = () => {
        const headers = [];
        const defineOrder = (item) => {
            if (orderBy === item) {
                const newDir = (orderDir === 'asc') ? 'desc' : 'asc';
                setOrderDir(newDir);
                return;
            }
            setOrderBy(item);
        }
        columns.forEach(item => {
            const waySign = (ORDER_DIR_NUM[orderDir] > 0) ? '▴' : '▾';
            const orderInd = (orderBy === item.name)
                ? {ordered: `${waySign}`}
                : {};
            const head = {
                ...item,
                ...orderInd,
                onClick: () => defineOrder(item.name),
            }
            headers.push(head);
        })
        return headers;
    }

    /** Adequa os dados ao formato para lista */
    const defineDataList = () => {
        const sortRows = (a, b) => {
            if (a[orderBy] < b[orderBy]) return (-1 * ORDER_DIR_NUM[orderDir]);
            if (a[orderBy] > b[orderBy]) return (1 * ORDER_DIR_NUM[orderDir]);
        }
        const dataList = [];
        const rows = filteredData || [];
        rows.sort(sortRows)
            .forEach(item => {
                const row = {
                    onClick: () => rowClick(item),
                    data: columns.map(col => {
                        // ---------------- cor/icone bloqueio ----------------
                        if (col.name === 'bloqueio') {
                            return {
                                value: (item[col.name] ? <FaRegCalendarCheck /> : <FaRegCalendar/>),
                                className: col.dynamicClass && col.dynamicClass(item[col.name]),
                                attr: {
                                    title: `${item[col.name] ? '' : 'Não '}Bloqueado`,
                                    'data-toggle': 'tooltip',
                                }
                            }
                        }
                        // ---------------- formato date dd/mm/yyyy ----------------
                        if (['dataInicio', 'dataFim'].includes(col.name)) {
                            return {
                                value: UtilService.apiDateToView(item[col.name]),
                                className: col.className
                            }
                        }

                        return {
                            value: item[col.name],
                            className: col.className
                        }
                    })
                }
                dataList.push(row);
            });
        return dataList;
    }

    /* Filtra a lista de dados */
    const filterList = (params) => {
        const { column, filter } = params;

        if (!column || !filter) {
            setFilteredData(rowsData);
            return
        }

        const filtered = rowsData.filter(item => {
            const lwData = String(item[column]).toLowerCase();
            const lwFilter = String(filter).toLowerCase();

            return lwData.includes(lwFilter);
        });
        setFilteredData(filtered);
    }

    /** Traz as funcoes cadastradas no database  */
    const getDataList = useCallback(async () => {
        setIsLoading(true);
        try {
            const resp = (await FechamentoApiService.getAll()).data;
            setRowsData(resp.data);
            setFilteredData(resp.data);
        }
        catch (err) {
            const errorService = new ErrorRequestService(err);
            const errorMsg = errorService.getErrors();
            console.log(errorMsg);
            alert.error(errorMsg);
        }
        finally {
            setIsLoading(false);
        }
    }, []);


    // EFFECTS
    useEffect(() => {
        if (!rowsData) getDataList();
    }, [rowsData, getDataList]);


    const pageActions = [
        {
            label: 'Novo',
            icon: <FaPlus />,
            color: 'primary',
            type: 'button',
            href: `${match.path}/new`,
        }
    ]

    const title = 'Lista de Fechamentos';

    return (
        <PageContainer
            title={title}
            actions={pageActions}
            infoButton={<FechamentolListHelpModal />}
        >
            { isLoading
                ? <Loading message="Carregando..." />
                : <ListLayout
                    columns={getListHeader()}
                    rows={defineDataList()}
                    onSubmitFilter={filterList}
                />
            }

        </PageContainer>
    )
}

export default FechamentolList;
